import React from 'react'
import styled from 'styled-components'
import { FaPowerOff } from "react-icons/fa";
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { showConfirmToast } from "./ConfirmToast"
import { sendCommand } from '../../../api/sendCommands';

function DeviceActions({
    total_consumption,
    setDevicePowerStatus,
    powerStatus,
    hwid,
    id,
    token
}) {
    const status = powerStatus || 0;
    const handleCortarServicio = async () => {
        const confirmed = await showConfirmToast(
        `¿Estás seguro de que deseas ${status === 0 ? 'restaurar el' : 'enviar un corte de'} servicio?`
        )

        if (!confirmed) {
            toast.warning("Acción cancelada", {
                position: "top-center",
                autoClose: 3000,
                className: "!rounded-xl",
            })
            return;
        } 


        const sendCommandPromise = sendCommand(hwid, id, status === 0 ? "restore" : "cut", token);
        
        try {
            const response = await toast.promise(sendCommandPromise, {
                pending: "Enviando comando...",
                success: {
                render: `${status === 0 ? 'Restauración de' : 'Corte de'} servicio enviado`,
                autoClose: 2000
                },
                error: {
                render: ({ data }) => data.message || "Error",
                autoClose: 5000
                }
            });
            if(setDevicePowerStatus) setDevicePowerStatus(status === 1 ? 0 : 1)
        } catch (err) {
            console.error(err);
        }
    }
    return (
        <Container>
            <div className="consumption">
                <h2>{total_consumption || 0}</h2>
                <p>KW/h consumidos</p>
            </div>
            <TogglePower onClick={handleCortarServicio} disabled={status === 0}>
                <FaPowerOff />
                <p>{status === 0 ? 'Restaurar' : 'Corte de'} servicio</p>
            </TogglePower>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: auto;
    gap: 2%;

    .consumption{
        display: flex;
        width: clamp(120px, 200px, 12vw);
        height: 15vh;
        flex-direction: column;
        box-shadow: 2px 2px 5px rgba(0, 0, 0, .3);
        justify-content: center;
        align-items: center;
        gap: 0.5rem;

        border-radius: 0.5rem;
        background-color: #34C759;
        color: #fff;
        box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
        transition: background-color 0.3s ease;

        svg{
            font-size: 36px;
        }
    }

    .consumption h2{
        margin: 0;
        text-align: center;
    }

    .consumption p, .toggle-power p{
        text-align: center;
        margin: 0;
        font-size: .7rem;
    }
`

const TogglePower = styled.div`

    display: flex;
    width: clamp(120px, 200px, 12vw);
    height: 15vh;
    flex-direction: column;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, .3);
    justify-content: center;
    align-items: center;
    gap: 0.5rem;

    border-radius: 0.5rem;
    background-color: ${({ disabled }) => disabled ? 'rgba(255, 58, 48, 0.843)' : '#34C759'};
    color: #fff;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
    transition: background-color 0.3s ease;

    svg{
        font-size: 36px;
    }

    &:hover{
        background-color: ${({ disabled }) => disabled ? 'rgba(223, 35, 25, 0.84)' : '#28A745'};
        cursor: pointer;
    }
`

export default DeviceActions